import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import {
  Bar,
  BarChart,
  Brush,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts'
import { Button, IcoArchive, IcoDownload, PopoverCentralAjuda, SafeHTML } from '../../components'
import { PageLoadView, convertChart } from '../../helpers'
import { CustomLabel, CustomTooltip, graficoOptions } from './graficoOptions'

export default ({ nlsContexto, nls }) => {
  const {
    benchmarkLoad,
    benchmarkData,
    benchmarkGrafico,
    benchmarkError
  } = useSelector(state => state.benchmarkState)

  const { titlePage } = useSelector(state => state.layoutState)
  const [download, setDownload] = useState(false)

  const idarray = [400]
  const imprimir = !benchmarkError && benchmarkGrafico?.length > 0

  const handleDownload = async () => {
    setDownload(true)
    const chartdownload = await convertChart({ id: 'benchmark-chart-download', titlePage })
    setDownload(chartdownload)
  }

  const getMensagemErro = () => {
    if (!benchmarkError) {
      return null
    }

    if (benchmarkError.iderro === 705) {
      return nls.benchmarkSemCadastro
    }

    if (benchmarkError.iderro === 706) {
      return nls.benchmarkSemDadosPeriodo
    }

    return nls.erroCarregarBenchmark
  }

  const renderInsight = (insight, index) => {
    const partes = insight.split(':')

    if (partes.length < 2) {
      return (
              <div
        className='box-benchmark-analise-grafica-item'
        data-cy='benchmark-analysis-item'
        key={`benchmark-insight-${index}`}
      >
          <SafeHTML html={insight} />
        </div>
      )
    }

    const titulo = partes.shift()
    const conteudo = partes.join(':').trim()

    return (
            <div
        className='box-benchmark-analise-grafica-item'
        data-cy='benchmark-analysis-item'
        key={`benchmark-insight-${index}`}
      >
        <strong>{titulo}:</strong> <SafeHTML html={conteudo} />
      </div>
    )
  }

  return (
    <>
          <div
      data-cy='benchmark-result'
      className={`box-benchmark-graficos box-content ${download ? 'graficos-download' : ''}`}
    >
        <div className='graficos-chart-box-action box-benchmark-graficos-action'>
                  <PopoverCentralAjuda
          cy='help'
          nlsContexto={nlsContexto}
          idarray={idarray}
        />

          {!benchmarkLoad && imprimir ? (
                      <Button
            data-cy='chart-download'
            type='btn circle'
            color='primary'
              variant='outlined'
              onClick={() => handleDownload()}
              title={nls.downloadgrafico}
            >
              <IcoDownload />
            </Button>
          ) : null}
        </div>

        <div id='benchmark-chart-download'>
                  <div
          id='benchmark-chart'
          data-cy='benchmark-chart'
          className='box-benchmark-graficos-chart'
        >
            

            <PageLoadView
              load={benchmarkLoad}
              data={benchmarkGrafico}
              semdadosparaexibir={!imprimir ? getMensagemErro() || nls.semdadosparaexibir : null}
            >
              {imprimir ? (
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart
                    width={graficoOptions.BarChart.width}
                    height={graficoOptions.BarChart.height}
                    data={benchmarkGrafico}
                    margin={graficoOptions.BarChart.margin}
                  >
                    <CartesianGrid
                      stroke={graficoOptions.CartesianGrid.stroke}
                      vertical={graficoOptions.CartesianGrid.vertical}
                    />

                    {benchmarkGrafico.length > graficoOptions.Brush.endIndex + 1 ? (
                      <Brush
                        dataKey={graficoOptions.Brush.dataKey}
                        height={graficoOptions.Brush.height}
                        stroke={graficoOptions.Brush.stroke}
                        startIndex={graficoOptions.Brush.startIndex}
                        endIndex={graficoOptions.Brush.endIndex}
                      />
                    ) : null}

                    <XAxis
                      dataKey={graficoOptions.XAxis.dataKey}
                      stroke={graficoOptions.XAxis.stroke}
                      axisLine={graficoOptions.XAxis.axisLine}
                      tickLine={graficoOptions.XAxis.tickLine}
                      fontSize={graficoOptions.XAxis.fontSize}
                    />

                    <YAxis
                      unit={graficoOptions.YAxis.unit}
                      stroke={graficoOptions.YAxis.stroke}
                      axisLine={graficoOptions.YAxis.axisLine}
                      tickLine={graficoOptions.YAxis.tickLine}
                      fontSize={graficoOptions.YAxis.fontSize}
                    />

                    <Tooltip content={<CustomTooltip msgNA={nls.Dadonaodisponivel} />} />

                    <Bar
                      dataKey="sfi"
                      radius={graficoOptions.Bar.radius}
                      label={<CustomLabel />}
                    >
                      {benchmarkGrafico.map((entry) => (
                        <Cell key={`cell-${entry.id}`} fill={entry.fill} />
                      ))}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              ) : null}
            </PageLoadView>
          </div>
        </div>
      </div>

      {imprimir && benchmarkData?.insights?.length ? (
              <div
        className='box-benchmark-analise-grafica box-content'
        data-cy='benchmark-analysis'
      >
          <h3><IcoArchive /> {nls.analise}</h3>

          <div className='box-benchmark-analise-grafica-lista'>
            {benchmarkData.insights.map((insight, index) => renderInsight(insight, index))}
          </div>
        </div>
      ) : null}
    </>
  )
}